var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 49,
    viewBox: "0 0 228 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9835 43.7627C97.9835 43.7627 99.9236 49.0673 106.402 47.5374C111.921 46.2339 113.484 48.0082 113.484 48.0082C113.484 48.0082 110.723 46.6413 106.402 48.3371C102.081 50.0358 97.7209 48.4577 97.9835 43.7627Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 43,
    width: 17,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9835 43.7627C97.9835 43.7627 99.9236 49.0673 106.402 47.5374C111.921 46.2339 113.484 48.0082 113.484 48.0082C113.484 48.0082 110.723 46.6413 106.402 48.3371C102.081 50.0358 97.7209 48.4577 97.9835 43.7627Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1404 43.7627H97.9714V50.0358H98.1404V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3095 43.7627H98.1405V50.0358H98.3095V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4784 43.7627H98.3094V50.0358H98.4784V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6474 43.7627H98.4784V50.0358H98.6474V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8134 43.7627H98.6444V50.0358H98.8134V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9823 43.7627H98.8134V50.0358H98.9823V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1512 43.7627H98.9822V50.0358H99.1512V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3202 43.7627H99.1512V50.0358H99.3202V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4892 43.7627H99.3202V50.0358H99.4892V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6582 43.7627H99.4893V50.0358H99.6582V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8272 43.7627H99.6582V50.0358H99.8272V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9961 43.7627H99.8271V50.0358H99.9961V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.162 43.7627H99.9932V50.0358H100.162V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.331 43.7627H100.162V50.0358H100.331V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 43.7627H100.331V50.0358H100.5V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.669 43.7627H100.5V50.0358H100.669V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.838 43.7627H100.669V50.0358H100.838V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.007 43.7627H100.838V50.0358H101.007V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.176 43.7627H101.007V50.0358H101.176V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.345 43.7627H101.176V50.0358H101.345V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.511 43.7627H101.342V50.0358H101.511V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68 43.7627H101.511V50.0358H101.68V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.849 43.7627H101.68V50.0358H101.849V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.018 43.7627H101.849V50.0358H102.018V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.187 43.7627H102.018V50.0358H102.187V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.356 43.7627H102.187V50.0358H102.356V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.525 43.7627H102.356V50.0358H102.525V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.694 43.7627H102.525V50.0358H102.694V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86 43.7627H102.691V50.0358H102.86V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.029 43.7627H102.86V50.0358H103.029V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.198 43.7627H103.029V50.0358H103.198V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.367 43.7627H103.198V50.0358H103.367V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.536 43.7627H103.367V50.0358H103.536V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.705 43.7627H103.536V50.0358H103.705V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.873 43.7627H103.704V50.0358H103.873V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.039 43.7627H103.87V50.0358H104.039V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.208 43.7627H104.039V50.0358H104.208V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.377 43.7627H104.208V50.0358H104.377V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.546 43.7627H104.377V50.0358H104.546V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.715 43.7627H104.546V50.0358H104.715V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.884 43.7627H104.715V50.0358H104.884V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.053 43.7627H104.884V50.0358H105.053V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.222 43.7627H105.053V50.0358H105.222V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.388 43.7627H105.219V50.0358H105.388V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.557 43.7627H105.388V50.0358H105.557V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.726 43.7627H105.557V50.0358H105.726V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.895 43.7627H105.726V50.0358H105.895V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.064 43.7627H105.895V50.0358H106.064V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.233 43.7627H106.064V50.0358H106.233V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.402 43.7627H106.233V50.0358H106.402V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.571 43.7627H106.402V50.0358H106.571V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.737 43.7627H106.568V50.0358H106.737V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.906 43.7627H106.737V50.0358H106.906V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.075 43.7627H106.906V50.0358H107.075V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.244 43.7627H107.075V50.0358H107.244V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.413 43.7627H107.244V50.0358H107.413V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.582 43.7627H107.413V50.0358H107.582V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.751 43.7627H107.582V50.0358H107.751V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92 43.7627H107.751V50.0358H107.92V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.086 43.7627H107.917V50.0358H108.086V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.255 43.7627H108.086V50.0358H108.255V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.424 43.7627H108.255V50.0358H108.424V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.593 43.7627H108.424V50.0358H108.593V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.762 43.7627H108.593V50.0358H108.762V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.931 43.7627H108.762V50.0358H108.931V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1 43.7627H108.931V50.0358H109.1V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.265 43.7627H109.096V50.0358H109.265V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.434 43.7627H109.266V50.0358H109.434V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.603 43.7627H109.434V50.0358H109.603V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.772 43.7627H109.604V50.0358H109.772V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.941 43.7627H109.772V50.0358H109.941V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.11 43.7627H109.941V50.0358H110.11V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.279 43.7627H110.11V50.0358H110.279V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.448 43.7627H110.279V50.0358H110.448V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.614 43.7627H110.445V50.0358H110.614V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.783 43.7627H110.614V50.0358H110.783V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.952 43.7627H110.783V50.0358H110.952V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.121 43.7627H110.952V50.0358H111.121V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29 43.7627H111.121V50.0358H111.29V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.459 43.7627H111.29V50.0358H111.459V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.628 43.7627H111.459V50.0358H111.628V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.797 43.7627H111.628V50.0358H111.797V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.963 43.7627H111.794V50.0358H111.963V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.132 43.7627H111.963V50.0358H112.132V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.301 43.7627H112.132V50.0358H112.301V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47 43.7627H112.301V50.0358H112.47V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.639 43.7627H112.47V50.0358H112.639V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.808 43.7627H112.639V50.0358H112.808V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.977 43.7627H112.808V50.0358H112.977V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.146 43.7627H112.977V50.0358H113.146V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.312 43.7627H113.143V50.0358H113.312V43.7627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.481 43.7627H113.312V50.0358H113.481V43.7627Z",
    fill: "#818181"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6307 37.67C97.6307 37.67 100.95 46.7463 112.03 44.1242C121.471 41.8913 124.144 44.9298 124.144 44.9298C124.144 44.9298 119.422 42.5883 112.03 45.4941C104.637 48.3998 97.1781 45.6993 97.6307 37.667V37.67Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 37,
    width: 28,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6307 37.67C97.6307 37.67 100.95 46.7463 112.03 44.1242C121.471 41.8913 124.144 44.9298 124.144 44.9298C124.144 44.9298 119.422 42.5883 112.03 45.4941C104.637 48.3998 97.1781 45.6993 97.6307 37.667V37.67Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.8991 37.6699H97.6094V48.4028H97.8991V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1887 37.6699H97.899V48.4028H98.1887V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4755 37.6699H98.1858V48.4028H98.4755V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7651 37.6699H98.4755V48.4028H98.7651V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0548 37.6699H98.7651V48.4028H99.0548V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3414 37.6699H99.0518V48.4028H99.3414V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6311 37.6699H99.3414V48.4028H99.6311V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9178 37.6699H99.6282V48.4028H99.9178V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.208 37.6699H99.9178V48.4028H100.208V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.494 37.6699H100.204V48.4028H100.494V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.784 37.6699H100.494V48.4028H100.784V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.073 37.6699H100.784V48.4028H101.073V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.36 37.6699H101.07V48.4028H101.36V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65 37.6699H101.36V48.4028H101.65V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.936 37.6699H101.647V48.4028H101.936V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.226 37.6699H101.936V48.4028H102.226V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.516 37.6699H102.226V48.4028H102.516V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.802 37.6699H102.513V48.4028H102.802V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.092 37.6699H102.802V48.4028H103.092V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.379 37.6699H103.089V48.4028H103.379V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.668 37.6699H103.379V48.4028H103.668V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.955 37.6699H103.665V48.4028H103.955V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.245 37.6699H103.955V48.4028H104.245V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.534 37.6699H104.245V48.4028H104.534V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.821 37.6699H104.531V48.4028H104.821V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.111 37.6699H104.821V48.4028H105.111V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.397 37.6699H105.108V48.4028H105.397V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.687 37.6699H105.397V48.4028H105.687V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.974 37.6699H105.684V48.4028H105.974V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.263 37.6699H105.974V48.4028H106.263V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.553 37.6699H106.263V48.4028H106.553V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.84 37.6699H106.55V48.4028H106.84V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.129 37.6699H106.84V48.4028H107.129V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.416 37.6699H107.126V48.4028H107.416V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.706 37.6699H107.416V48.4028H107.706V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.995 37.6699H107.706V48.4028H107.995V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.282 37.6699H107.992V48.4028H108.282V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.572 37.6699H108.282V48.4028H108.572V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.858 37.6699H108.569V48.4028H108.858V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 37.6699H108.858V48.4028H109.148V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.435 37.6699H109.145V48.4028H109.435V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.724 37.6699H109.435V48.4028H109.724V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.014 37.6699H109.724V48.4028H110.014V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.301 37.6699H110.011V48.4028H110.301V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.59 37.6699H110.301V48.4028H110.59V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.877 37.6699H110.587V48.4028H110.877V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.167 37.6699H110.877V48.4028H111.167V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.453 37.6699H111.163V48.4028H111.453V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.743 37.6699H111.453V48.4028H111.743V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.032 37.6699H111.743V48.4028H112.032V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.319 37.6699H112.03V48.4028H112.319V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.609 37.6699H112.319V48.4028H112.609V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.896 37.6699H112.606V48.4028H112.896V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.185 37.6699H112.896V48.4028H113.185V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.472 37.6699H113.182V48.4028H113.472V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.762 37.6699H113.472V48.4028H113.762V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.051 37.6699H113.762V48.4028H114.051V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.338 37.6699H114.048V48.4028H114.338V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.627 37.6699H114.338V48.4028H114.627V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.914 37.6699H114.625V48.4028H114.914V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.204 37.6699H114.914V48.4028H115.204V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.494 37.6699H115.204V48.4028H115.494V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.78 37.6699H115.49V48.4028H115.78V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07 37.6699H115.78V48.4028H116.07V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.357 37.6699H116.067V48.4028H116.357V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.646 37.6699H116.357V48.4028H116.646V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.933 37.6699H116.643V48.4028H116.933V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.222 37.6699H116.933V48.4028H117.222V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.512 37.6699H117.222V48.4028H117.512V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.799 37.6699H117.509V48.4028H117.799V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.088 37.6699H117.799V48.4028H118.088V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.375 37.6699H118.085V48.4028H118.375V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.665 37.6699H118.375V48.4028H118.665V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.951 37.6699H118.662V48.4028H118.951V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.241 37.6699H118.952V48.4028H119.241V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.531 37.6699H119.241V48.4028H119.531V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.817 37.6699H119.528V48.4028H119.817V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.107 37.6699H119.817V48.4028H120.107V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.394 37.6699H120.104V48.4028H120.394V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.683 37.6699H120.394V48.4028H120.683V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.97 37.6699H120.68V48.4028H120.97V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.26 37.6699H120.97V48.4028H121.26V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.549 37.6699H121.26V48.4028H121.549V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.836 37.6699H121.546V48.4028H121.836V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.126 37.6699H121.836V48.4028H122.126V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.412 37.6699H122.123V48.4028H122.412V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.702 37.6699H122.412V48.4028H122.702V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.992 37.6699H122.702V48.4028H122.992V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.278 37.6699H122.989V48.4028H123.278V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.568 37.6699H123.278V48.4028H123.568V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.855 37.6699H123.565V48.4028H123.855V37.6699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.144 37.6699H123.855V48.4028H124.144V37.6699Z",
    fill: "#818181"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.778 33.1565L117.796 33.3345C117.959 34.9035 116.791 36.3368 115.225 36.4967L114.751 36.545L112.669 16.416L115.717 16.1022L115.137 10.502L109.516 13.3081L112.53 42.4802L115.804 42.1423C120.463 41.6595 123.833 37.4623 123.351 32.8035L123.333 32.6254L117.772 33.1535L117.778 33.1565Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 10,
    width: 15,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.778 33.1565L117.796 33.3345C117.959 34.9035 116.791 36.3368 115.225 36.4967L114.751 36.545L112.669 16.416L115.717 16.1022L115.137 10.502L109.516 13.3081L112.53 42.4802L115.804 42.1423C120.463 41.6595 123.833 37.4623 123.351 32.8035L123.333 32.6254L117.772 33.1535L117.778 33.1565Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.519 13.3105L112.533 42.4826H109.519V13.3105Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.519 12.0674L112.663 42.4826H112.533L109.519 13.3105V12.0674Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.519 10.8242L112.793 42.4826H112.663L109.519 12.0674V10.8242Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.615 10.5049L112.92 42.4831H112.793L109.519 10.8247V10.5049H109.615Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.742 10.5049L113.049 42.4831H112.92L109.615 10.5049H109.742Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.872 10.5049L113.176 42.4831H113.049L109.742 10.5049H109.872Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 10.5049L113.306 42.4831H113.176L109.872 10.5049H109.999Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.129 10.5049L113.436 42.4831H113.306L109.999 10.5049H110.129Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.258 10.5049L113.562 42.4831H113.436L110.129 10.5049H110.258Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.385 10.5049L113.692 42.4831H113.562L110.258 10.5049H110.385Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.515 10.5049L113.819 42.4831H113.692L110.385 10.5049H110.515Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.641 10.5049L113.949 42.4831H113.819L110.515 10.5049H110.641Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.771 10.5049L114.075 42.4831H113.949L110.641 10.5049H110.771Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.901 10.5049L114.205 42.4831H114.075L110.771 10.5049H110.901Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.028 10.5049L114.335 42.4831H114.205L110.901 10.5049H111.028Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.157 10.5049L114.461 42.4831H114.335L111.028 10.5049H111.157Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.284 10.5049L114.591 42.4831H114.461L111.157 10.5049H111.284Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.414 10.5049L114.718 42.4831H114.591L111.284 10.5049H111.414Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.544 10.5049L114.848 42.4831H114.718L111.414 10.5049H111.544Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67 10.5049L114.977 42.4831H114.848L111.544 10.5049H111.67Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8 10.5049L115.104 42.4831H114.977L111.67 10.5049H111.8Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.927 10.5049L115.234 42.4831H115.104L111.8 10.5049H111.927Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.057 10.5049L115.361 42.4831H115.234L111.927 10.5049H112.057Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.186 10.5049L115.49 42.4831H115.361L112.057 10.5049H112.186Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.313 10.5049L115.62 42.4831H115.49L112.186 10.5049H112.313Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.443 10.5049L115.747 42.4831H115.62L112.313 10.5049H112.443Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57 10.5049L115.877 42.4831H115.747L112.443 10.5049H112.57Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.699 10.5049L116.003 42.4831H115.877L112.57 10.5049H112.699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.826 10.5049L116.133 42.4831H116.003L112.699 10.5049H112.826Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.956 10.5049L116.263 42.4831H116.133L112.826 10.5049H112.956Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.086 10.5049L116.39 42.4831H116.263L112.956 10.5049H113.086Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.212 10.5049L116.519 42.4831H116.389L113.085 10.5049H113.212Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.342 10.5049L116.646 42.4831H116.519L113.212 10.5049H113.342Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.469 10.5049L116.776 42.4831H116.646L113.342 10.5049H113.469Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.599 10.5049L116.903 42.4831H116.776L113.469 10.5049H113.599Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.728 10.5049L117.032 42.4831H116.903L113.599 10.5049H113.728Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.855 10.5049L117.162 42.4831H117.032L113.728 10.5049H113.855Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.985 10.5049L117.289 42.4831H117.162L113.855 10.5049H113.985Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.111 10.5049L117.419 42.4831H117.289L113.985 10.5049H114.111Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.241 10.5049L117.545 42.4831H117.419L114.111 10.5049H114.241Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.371 10.5049L117.675 42.4831H117.545L114.241 10.5049H114.371Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.498 10.5049L117.805 42.4831H117.675L114.371 10.5049H114.498Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.627 10.5049L117.931 42.4831H117.805L114.498 10.5049H114.627Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.754 10.5049L118.061 42.4831H117.931L114.627 10.5049H114.754Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.884 10.5049L118.188 42.4831H118.061L114.754 10.5049H114.884Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.014 10.5049L118.318 42.4831H118.188L114.884 10.5049H115.014Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14 10.5049L118.447 42.4831H118.318L115.014 10.5049H115.14Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.27 10.5049L118.574 42.4831H118.447L115.14 10.5049H115.27Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.397 10.5049L118.704 42.4831H118.574L115.27 10.5049H115.397Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.527 10.5049L118.831 42.4831H118.704L115.397 10.5049H115.527Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.653 10.5049L118.96 42.4831H118.831L115.527 10.5049H115.653Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.783 10.5049L119.087 42.4831H118.96L115.653 10.5049H115.783Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.913 10.5049L119.217 42.4831H119.087L115.783 10.5049H115.913Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.04 10.5049L119.347 42.4831H119.217L115.913 10.5049H116.04Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.169 10.5049L119.473 42.4831H119.347L116.04 10.5049H116.169Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.296 10.5049L119.603 42.4831H119.473L116.169 10.5049H116.296Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.426 10.5049L119.73 42.4831H119.603L116.296 10.5049H116.426Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.556 10.5049L119.86 42.4831H119.73L116.426 10.5049H116.556Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.682 10.5049L119.989 42.4831H119.859L116.555 10.5049H116.682Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.812 10.5049L120.116 42.4831H119.989L116.682 10.5049H116.812Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.939 10.5049L120.246 42.4831H120.116L116.812 10.5049H116.939Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.068 10.5049L120.373 42.4831H120.246L116.939 10.5049H117.068Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.198 10.5049L120.502 42.4831H120.373L117.069 10.5049H117.198Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.325 10.5049L120.632 42.4831H120.502L117.198 10.5049H117.325Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.455 10.5049L120.759 42.4831H120.632L117.325 10.5049H117.455Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.582 10.5049L120.889 42.4831H120.759L117.455 10.5049H117.582Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.711 10.5049L121.015 42.4831H120.888L117.581 10.5049H117.711Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.838 10.5049L121.145 42.4831H121.015L117.711 10.5049H117.838Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.968 10.5049L121.275 42.4831H121.145L117.838 10.5049H117.968Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.097 10.5049L121.401 42.4831H121.275L117.968 10.5049H118.097Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.224 10.5049L121.531 42.4831H121.401L118.097 10.5049H118.224Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.354 10.5049L121.658 42.4831H121.531L118.224 10.5049H118.354Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.481 10.5049L121.788 42.4831H121.658L118.354 10.5049H118.481Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.61 10.5049L121.914 42.4831H121.788L118.481 10.5049H118.61Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74 10.5049L122.044 42.4831H121.915L118.61 10.5049H118.74Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.867 10.5049L122.174 42.4831H122.044L118.74 10.5049H118.867Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.997 10.5049L122.301 42.4831H122.174L118.867 10.5049H118.997Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.123 10.5049L122.43 42.4831H122.301L118.997 10.5049H119.123Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.253 10.5049L122.557 42.4831H122.43L119.123 10.5049H119.253Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.383 10.5049L122.687 42.4831H122.557L119.253 10.5049H119.383Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51 10.5049L122.817 42.4831H122.687L119.383 10.5049H119.51Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.639 10.5049L122.943 42.4831H122.817L119.51 10.5049H119.639Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.766 10.5049L123.073 42.4831H122.943L119.639 10.5049H119.766Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.896 10.5049L123.2 42.4831H123.073L119.766 10.5049H119.896Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.025 10.5049L123.33 42.4831H123.2L119.896 10.5049H120.025Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.152 10.5049L123.459 42.4831H123.33L120.026 10.5049H120.152Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.282 10.5049L123.586 42.4831H123.459L120.152 10.5049H120.282Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.409 10.5049L123.716 42.4831H123.586L120.282 10.5049H120.409Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538 10.5049L123.839 42.4379V42.4831H123.716L120.409 10.5049H120.538Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.665 10.5049L123.84 41.1947V42.4379L120.539 10.5049H120.665Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.795 10.5049L123.84 39.9515V41.1947L120.665 10.5049H120.795Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.925 10.5049L123.839 38.7084V39.9515L120.795 10.5049H120.925Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.052 10.5049L123.84 37.4652V38.7084L120.925 10.5049H121.052Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84 37.4652L121.052 10.5049H123.84V37.4652Z",
    fill: "#818181"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.442 11.7139L104.021 17.3141L107.069 17.0003L109.151 37.1293L108.97 37.1474C107.401 37.3104 105.968 36.1426 105.808 34.5766L105.79 34.3986L100.192 35.0232L100.21 35.2012C100.693 39.86 104.893 43.2757 109.552 42.7929L112.533 42.4852L109.519 13.3131L103.442 11.7169V11.7139Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 11,
    width: 13,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.442 11.7139L104.021 17.3141L107.069 17.0003L109.151 37.1293L108.97 37.1474C107.401 37.3104 105.968 36.1426 105.808 34.5766L105.79 34.3986L100.192 35.0232L100.21 35.2012C100.693 39.86 104.893 43.2757 109.552 42.7929L112.533 42.4852L109.519 13.3131L103.442 11.7169V11.7139Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.192 35.0205L101.046 43.2731H100.192V35.0205Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 33.8047L101.17 43.2732H101.046L100.192 35.0207V33.8047Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 32.5859L101.297 43.2735H101.17L100.192 33.805V32.5859Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 31.3701L101.423 43.2737H101.297L100.192 32.5861V31.3701Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 30.1533L101.547 43.2729H101.423L100.192 31.3693V30.1533Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 28.9355L101.674 43.2742H101.547L100.192 30.1546V28.9355Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 27.7188L101.801 43.2734H101.674L100.192 28.9348V27.7188Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 26.5029L101.924 43.2736H101.801L100.192 27.7189V26.5029Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 25.2871L102.051 43.2737H101.924L100.192 26.5031V25.2871Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 24.0684L102.178 43.274H102.051L100.192 25.2874V24.0684Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 22.8516L102.301 43.2732H102.178L100.192 24.0676V22.8516Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 21.6357L102.428 43.2734H102.301L100.192 22.8517V21.6357Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 20.417L102.555 43.2737H102.428L100.192 21.636V20.417Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 19.2012L102.679 43.2739H102.555L100.192 20.4172V19.2012Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 17.9844L102.805 43.2731H102.679L100.192 19.2004V17.9844Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 16.7695L102.932 43.2742H102.805L100.192 17.9855V16.7695Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 15.5498L103.056 43.2735H102.932L100.192 16.7688V15.5498Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 14.334L103.182 43.2737H103.056L100.192 15.55V14.334Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 13.1182L103.309 43.2739H103.182L100.192 14.3342V13.1182Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.192 11.8994L103.436 43.2742H103.309L100.192 13.1184V11.8994Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.298 11.7139L103.56 43.2727H103.436L100.192 11.8979V11.7139H100.298Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.425 11.7139L103.686 43.2727H103.56L100.298 11.7139H100.425Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.548 11.7139L103.813 43.2727H103.686L100.425 11.7139H100.548Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.675 11.7139L103.937 43.2727H103.813L100.548 11.7139H100.675Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.802 11.7139L104.064 43.2727H103.937L100.675 11.7139H100.802Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.928 11.7139L104.19 43.2727H104.064L100.802 11.7139H100.928Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.052 11.7139L104.314 43.2727H104.19L100.928 11.7139H101.052Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.179 11.7139L104.441 43.2727H104.314L101.052 11.7139H101.179Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.306 11.7139L104.567 43.2727H104.441L101.179 11.7139H101.306Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.429 11.7139L104.691 43.2727H104.567L101.306 11.7139H101.429Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.556 11.7139L104.818 43.2727H104.691L101.429 11.7139H101.556Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.683 11.7139L104.945 43.2727H104.818L101.556 11.7139H101.683Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.807 11.7139L105.068 43.2727H104.945L101.683 11.7139H101.807Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.933 11.7139L105.195 43.2727H105.068L101.807 11.7139H101.933Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.06 11.7139L105.322 43.2727H105.195L101.933 11.7139H102.06Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.184 11.7139L105.446 43.2727H105.322L102.06 11.7139H102.184Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.31 11.7139L105.572 43.2727H105.446L102.184 11.7139H102.31Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.437 11.7139L105.699 43.2727H105.572L102.31 11.7139H102.437Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.561 11.7139L105.826 43.2727H105.699L102.437 11.7139H102.561Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688 11.7139L105.949 43.2727H105.826L102.561 11.7139H102.688Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.814 11.7139L106.076 43.2727H105.949L102.688 11.7139H102.814Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.938 11.7139L106.203 43.2727H106.076L102.814 11.7139H102.938Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.065 11.7139L106.327 43.2727H106.203L102.938 11.7139H103.065Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.192 11.7139L106.453 43.2727H106.327L103.065 11.7139H103.192Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.318 11.7139L106.58 43.2727H106.453L103.192 11.7139H103.318Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.442 11.7139L106.704 43.2727H106.58L103.318 11.7139H103.442Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.569 11.7139L106.831 43.2727H106.704L103.442 11.7139H103.569Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.695 11.7139L106.957 43.2727H106.831L103.569 11.7139H103.695Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.819 11.7139L107.081 43.2727H106.957L103.695 11.7139H103.819Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.946 11.7139L107.208 43.2727H107.081L103.819 11.7139H103.946Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.073 11.7139L107.334 43.2727H107.208L103.946 11.7139H104.073Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.196 11.7139L107.458 43.2727H107.334L104.073 11.7139H104.196Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.323 11.7139L107.585 43.2727H107.458L104.196 11.7139H104.323Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45 11.7139L107.712 43.2727H107.585L104.323 11.7139H104.45Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.574 11.7139L107.835 43.2727H107.712L104.45 11.7139H104.574Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7 11.7139L107.962 43.2727H107.835L104.574 11.7139H104.7Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.827 11.7139L108.089 43.2727H107.962L104.7 11.7139H104.827Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.951 11.7139L108.216 43.2727H108.089L104.827 11.7139H104.951Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.077 11.7139L108.339 43.2727H108.215L104.951 11.7139H105.077Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.204 11.7139L108.466 43.2727H108.339L105.077 11.7139H105.204Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.328 11.7139L108.593 43.2727H108.466L105.204 11.7139H105.328Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.454 11.7139L108.716 43.2727H108.593L105.328 11.7139H105.454Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.581 11.7139L108.843 43.2727H108.716L105.454 11.7139H105.581Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 11.7139L108.97 43.2727H108.843L105.581 11.7139H105.708Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.832 11.7139L109.094 43.2727H108.97L105.708 11.7139H105.832Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.958 11.7139L109.22 43.2727H109.093L105.832 11.7139H105.958Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.085 11.7139L109.347 43.2727H109.22L105.958 11.7139H106.085Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.209 11.7139L109.471 43.2727H109.347L106.085 11.7139H106.209Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.336 11.7139L109.597 43.2727H109.471L106.209 11.7139H106.336Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.462 11.7139L109.724 43.2727H109.597L106.336 11.7139H106.462Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.586 11.7139L109.848 43.2727H109.724L106.462 11.7139H106.586Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.713 11.7139L109.975 43.2727H109.848L106.586 11.7139H106.713Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.839 11.7139L110.101 43.2727H109.975L106.713 11.7139H106.839Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.963 11.7139L110.225 43.2727H110.101L106.84 11.7139H106.963Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 11.7139L110.352 43.2727H110.225L106.963 11.7139H107.09Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.217 11.7139L110.478 43.2727H110.352L107.09 11.7139H107.217Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34 11.7139L110.602 43.2727H110.478L107.217 11.7139H107.34Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.467 11.7139L110.729 43.2727H110.602L107.34 11.7139H107.467Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.594 11.7139L110.856 43.2727H110.729L107.467 11.7139H107.594Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.718 11.7139L110.982 43.2727H110.856L107.594 11.7139H107.718Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.844 11.7139L111.106 43.2727H110.982L107.718 11.7139H107.844Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.971 11.7139L111.233 43.2727H111.106L107.844 11.7139H107.971Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.098 11.7139L111.36 43.2727H111.233L107.971 11.7139H108.098Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.221 11.7139L111.483 43.2727H111.36L108.098 11.7139H108.221Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.348 11.7139L111.61 43.2727H111.483L108.221 11.7139H108.348Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.475 11.7139L111.737 43.2727H111.61L108.348 11.7139H108.475Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.599 11.7139L111.86 43.2727H111.737L108.475 11.7139H108.599Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.725 11.7139L111.987 43.2727H111.86L108.599 11.7139H108.725Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.852 11.7139L112.114 43.2727H111.987L108.725 11.7139H108.852Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 11.7139L112.238 43.2727H112.114L108.852 11.7139H108.976Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.103 11.7139L112.364 43.2727H112.238L108.976 11.7139H109.103Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.229 11.7139L112.491 43.2727H112.364L109.103 11.7139H109.229Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.353 11.7139L112.533 42.4821V43.2727H112.491L109.229 11.7139H109.353Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.533 42.4821L109.353 11.7139H112.533V42.4821Z",
    fill: "#818181"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.14 10.5049L109.293 11.1084H109.29L103.442 11.7149L109.519 13.3111L115.14 10.5049Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 10,
    width: 13,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.14 10.5049L109.293 11.1084H109.29L103.442 11.7149L109.519 13.3111L115.14 10.5049Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.442 11.7139L103.608 13.3101H103.442V11.7139Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.448 10.5049L103.738 13.3111H103.608L103.442 11.7149V10.5049H103.448Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.575 10.5049L103.864 13.3111H103.738L103.448 10.5049H103.575Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.704 10.5049L103.994 13.3111H103.864L103.575 10.5049H103.704Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.831 10.5049L104.121 13.3111H103.994L103.704 10.5049H103.831Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.961 10.5049L104.251 13.3111H104.121L103.831 10.5049H103.961Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.091 10.5049L104.38 13.3111H104.251L103.961 10.5049H104.091Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.217 10.5049L104.507 13.3111H104.38L104.091 10.5049H104.217Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.347 10.5049L104.637 13.3111H104.507L104.218 10.5049H104.347Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.474 10.5049L104.764 13.3111H104.637L104.347 10.5049H104.474Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.604 10.5049L104.893 13.3111H104.764L104.474 10.5049H104.604Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73 10.5049L105.023 13.3111H104.893L104.604 10.5049H104.73Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.86 10.5049L105.15 13.3111H105.023L104.73 10.5049H104.86Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.99 10.5049L105.28 13.3111H105.15L104.86 10.5049H104.99Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.117 10.5049L105.406 13.3111H105.28L104.99 10.5049H105.117Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.246 10.5049L105.536 13.3111H105.406L105.117 10.5049H105.246Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.373 10.5049L105.663 13.3111H105.536L105.246 10.5049H105.373Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.503 10.5049L105.792 13.3111H105.663L105.373 10.5049H105.503Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.633 10.5049L105.922 13.3111H105.792L105.503 10.5049H105.633Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.759 10.5049L106.049 13.3111H105.922L105.633 10.5049H105.759Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.889 10.5049L106.179 13.3111H106.049L105.759 10.5049H105.889Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.016 10.5049L106.305 13.3111H106.179L105.889 10.5049H106.016Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.146 10.5049L106.435 13.3111H106.306L106.016 10.5049H106.146Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.272 10.5049L106.565 13.3111H106.435L106.146 10.5049H106.272Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.402 10.5049L106.692 13.3111H106.565L106.272 10.5049H106.402Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.532 10.5049L106.821 13.3111H106.692L106.402 10.5049H106.532Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.659 10.5049L106.948 13.3111H106.822L106.532 10.5049H106.659Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.788 10.5049L107.078 13.3111H106.948L106.659 10.5049H106.788Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.915 10.5049L107.205 13.3111H107.078L106.788 10.5049H106.915Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.045 10.5049L107.334 13.3111H107.205L106.915 10.5049H107.045Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.175 10.5049L107.464 13.3111H107.334L107.045 10.5049H107.175Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.301 10.5049L107.591 13.3111H107.464L107.174 10.5049H107.301Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.431 10.5049L107.721 13.3111H107.591L107.301 10.5049H107.431Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.558 10.5049L107.847 13.3111H107.721L107.431 10.5049H107.558Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.687 10.5049L107.977 13.3111H107.847L107.558 10.5049H107.687Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.814 10.5049L108.107 13.3111H107.977L107.687 10.5049H107.814Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.944 10.5049L108.234 13.3111H108.107L107.814 10.5049H107.944Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.074 10.5049L108.363 13.3111H108.234L107.944 10.5049H108.074Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2 10.5049L108.49 13.3111H108.363L108.074 10.5049H108.2Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33 10.5049L108.62 13.3111H108.49L108.2 10.5049H108.33Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.457 10.5049L108.746 13.3111H108.62L108.33 10.5049H108.457Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.587 10.5049L108.876 13.3111H108.746L108.457 10.5049H108.587Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.716 10.5049L109.006 13.3111H108.876L108.587 10.5049H108.716Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.843 10.5049L109.133 13.3111H109.006L108.716 10.5049H108.843Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.973 10.5049L109.262 13.3111H109.133L108.843 10.5049H108.973Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1 10.5049L109.389 13.3111H109.263L108.973 10.5049H109.1Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.229 10.5049L109.519 13.3111H109.389L109.1 10.5049H109.229Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.356 10.5049L109.649 13.3111H109.519L109.229 10.5049H109.356Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.486 10.5049L109.775 13.3111H109.649L109.356 10.5049H109.486Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.616 10.5049L109.905 13.3111H109.776L109.486 10.5049H109.616Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.742 10.5049L110.032 13.3111H109.905L109.615 10.5049H109.742Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.872 10.5049L110.162 13.3111H110.032L109.742 10.5049H109.872Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 10.5049L110.288 13.3111H110.162L109.872 10.5049H109.999Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.129 10.5049L110.418 13.3111H110.288L109.999 10.5049H110.129Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.258 10.5049L110.548 13.3111H110.418L110.129 10.5049H110.258Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.385 10.5049L110.675 13.3111H110.548L110.258 10.5049H110.385Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.515 10.5049L110.804 13.3111H110.675L110.385 10.5049H110.515Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.641 10.5049L110.931 13.3111H110.804L110.515 10.5049H110.641Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.771 10.5049L111.061 13.3111H110.931L110.641 10.5049H110.771Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.898 10.5049L111.191 13.3111H111.061L110.771 10.5049H110.898Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.028 10.5049L111.317 13.3111H111.191L110.898 10.5049H111.028Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.157 10.5049L111.447 13.3111H111.317L111.028 10.5049H111.157Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.284 10.5049L111.574 13.3111H111.447L111.157 10.5049H111.284Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.414 10.5049L111.704 13.3111H111.574L111.284 10.5049H111.414Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.541 10.5049L111.83 13.3111H111.704L111.414 10.5049H111.541Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67 10.5049L111.96 13.3111H111.83L111.541 10.5049H111.67Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8 10.5049L112.09 13.3111H111.96L111.67 10.5049H111.8Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.927 10.5049L112.217 13.3111H112.09L111.8 10.5049H111.927Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.057 10.5049L112.346 13.3111H112.217L111.927 10.5049H112.057Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.183 10.5049L112.473 13.3111H112.346L112.057 10.5049H112.183Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.313 10.5049L112.603 13.3111H112.473L112.183 10.5049H112.313Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44 10.5049L112.733 13.3111H112.603L112.313 10.5049H112.44Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57 10.5049L112.859 13.3111H112.732L112.44 10.5049H112.57Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.699 10.5049L112.989 13.3111H112.859L112.57 10.5049H112.699Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.826 10.5049L113.116 13.3111H112.989L112.699 10.5049H112.826Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.956 10.5049L113.245 13.3111H113.116L112.826 10.5049H112.956Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.083 10.5049L113.372 13.3111H113.245L112.956 10.5049H113.083Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.212 10.5049L113.502 13.3111H113.372L113.083 10.5049H113.212Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.342 10.5049L113.632 13.3111H113.502L113.212 10.5049H113.342Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.469 10.5049L113.758 13.3111H113.632L113.342 10.5049H113.469Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.599 10.5049L113.888 13.3111H113.758L113.469 10.5049H113.599Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.725 10.5049L114.015 13.3111H113.888L113.599 10.5049H113.725Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.855 10.5049L114.145 13.3111H114.015L113.725 10.5049H113.855Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.982 10.5049L114.274 13.3111H114.145L113.855 10.5049H113.982Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.111 10.5049L114.401 13.3111H114.274L113.982 10.5049H114.111Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.241 10.5049L114.531 13.3111H114.401L114.111 10.5049H114.241Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.368 10.5049L114.658 13.3111H114.531L114.241 10.5049H114.368Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.498 10.5049L114.787 13.3111H114.658L114.368 10.5049H114.498Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.624 10.5049L114.914 13.3111H114.787L114.498 10.5049H114.624Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.754 10.5049L115.044 13.3111H114.914L114.624 10.5049H114.754Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.884 10.5049L115.14 12.9912V13.3111H115.044L114.754 10.5049H114.884Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.011 10.5049L115.14 11.748V12.9912L114.884 10.5049H115.011Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14 11.748L115.011 10.5049H115.14V11.748Z",
    fill: "#818181"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.293 0.601562C107.31 0.601562 105.708 2.20681 105.708 4.18622C105.708 6.16562 109.293 10.5046 109.293 10.5046C109.293 10.5046 112.877 6.16562 112.877 4.18622C112.877 2.20681 111.272 0.601562 109.293 0.601562ZM109.314 5.29963C108.744 5.3117 108.27 4.85909 108.255 4.28881C108.243 3.71852 108.695 3.24479 109.266 3.22971C109.836 3.21764 110.31 3.67024 110.325 4.24053C110.337 4.81082 109.884 5.28454 109.314 5.29963Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_164_1179",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 0,
    width: 8,
    height: 11
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.293 0.601562C107.31 0.601562 105.708 2.20681 105.708 4.18622C105.708 6.16562 109.293 10.5046 109.293 10.5046C109.293 10.5046 112.877 6.16562 112.877 4.18622C112.877 2.20681 111.272 0.601562 109.293 0.601562ZM109.314 5.29963C108.744 5.3117 108.27 4.85909 108.255 4.28881C108.243 3.71852 108.695 3.24479 109.266 3.22971C109.836 3.21764 110.31 3.67024 110.325 4.24053C110.337 4.81082 109.884 5.28454 109.314 5.29963Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_164_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.297 5.31488L110.34 5.2666V5.31488H110.297Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.207 5.31502L110.34 5.16113V5.26674L110.298 5.31502H110.207Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.116 5.31418L110.34 5.05469V5.1603L110.207 5.31418H110.116Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.026 5.31432L110.34 4.94922V5.05483L110.117 5.31432H110.026Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.932 5.31535L110.34 4.84766V4.95025L110.026 5.31535H109.932Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.842 5.31451L110.34 4.74121V4.84682L109.932 5.31451H109.842Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.751 5.31465L110.34 4.63574V4.74135L109.842 5.31465H109.751Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.661 5.31471L110.34 4.5332V4.63579L109.751 5.31471H109.661Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57 5.31485L110.34 4.42773V4.53334L109.661 5.31485H109.57Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.48 5.31499L110.34 4.32227V4.42787L109.57 5.31499H109.48Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.389 5.31504L110.34 4.21973V4.32232L109.48 5.31504H109.389Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.296 5.3142L110.34 4.11328V4.21889L109.389 5.3142H109.296Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.205 5.31434L110.34 4.00781V4.11342L109.296 5.31434H109.205Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.115 5.31537L110.34 3.90625V4.00884L109.205 5.31537H109.115Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.024 5.31453L110.34 3.7998V3.90541L109.115 5.31453H109.024Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.934 5.31467L110.34 3.69434V3.79994L109.024 5.31467H108.934Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.843 5.31481L110.34 3.58887V3.69448L108.934 5.31481H108.843Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.753 5.31486L110.34 3.48633V3.58892L108.843 5.31486H108.753Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.659 5.315L110.34 3.38086V3.48647L108.753 5.315H108.659Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.569 5.31514L110.34 3.27539V3.381L108.659 5.31514H108.569Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.478 5.31486L110.301 3.21777H110.34V3.2751L108.569 5.31486H108.478Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.388 5.31486L110.207 3.21777H110.301L108.478 5.31486H108.388Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.297 5.31486L110.117 3.21777H110.207L108.388 5.31486H108.297Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 5.2696L110.026 3.21777H110.116L108.297 5.31486H108.243V5.2696Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 5.167L109.935 3.21777H110.026L108.243 5.2696V5.167Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 5.0614L109.845 3.21777H109.935L108.243 5.167V5.0614Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.95579L109.754 3.21777H109.845L108.243 5.0614V4.95579Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.85018L109.664 3.21777H109.754L108.243 4.95579V4.85018Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.74759L109.573 3.21777H109.664L108.243 4.85018V4.74759Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.64198L109.48 3.21777H109.573L108.243 4.74759V4.64198Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.53637L109.389 3.21777H109.48L108.243 4.64198V4.53637Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.43378L109.299 3.21777H109.389L108.243 4.53637V4.43378Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.32817L109.208 3.21777H109.299L108.243 4.43378V4.32817Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.22256L109.118 3.21777H109.208L108.243 4.32817V4.22256Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.11997L109.027 3.21777H109.118L108.243 4.22256V4.11997Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 4.01436L108.937 3.21777H109.027L108.243 4.11997V4.01436Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.90875L108.843 3.21777H108.937L108.243 4.01436V3.90875Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.80616L108.753 3.21777H108.843L108.243 3.90875V3.80616Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.70056L108.662 3.21777H108.753L108.243 3.80616V3.70056Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.59495L108.572 3.21777H108.662L108.243 3.70056V3.59495Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.48934L108.481 3.21777H108.572L108.243 3.59495V3.48934Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.38675L108.391 3.21777H108.481L108.243 3.48934V3.38675Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 3.28114L108.3 3.21777H108.391L108.243 3.38675V3.28114Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3 3.21777L108.243 3.28114V3.21777H108.3Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.971 10.505L112.874 4.85645V10.505H107.971Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.881 10.5041L112.874 4.75293V4.85552L107.971 10.5041H107.881Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.787 10.5042L112.874 4.64746V4.75307L107.881 10.5042H107.787Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.697 10.5043L112.874 4.54199V4.6476L107.787 10.5043H107.697Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.606 10.5044L112.874 4.43945V4.54204L107.696 10.5044H107.606Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.516 10.5045L112.874 4.33398V4.43959L107.606 10.5045H107.516Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.425 10.5047L112.874 4.22852V4.33412L107.515 10.5047H107.425Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.334 10.5038L112.874 4.125V4.22759L107.425 10.5038H107.334Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.244 10.5049L112.874 4.02051V4.12612L107.335 10.5049H107.244Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15 10.505L112.874 3.91504V4.02065L107.244 10.505H107.15Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06 10.5041L112.874 3.81152V3.91411L107.15 10.5041H107.06Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.969 10.5042L112.874 3.70605V3.81166L107.06 10.5042H106.969Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.879 10.5053L112.874 3.60156V3.70717L106.969 10.5053H106.879Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.788 10.5045L112.874 3.49512V3.60073L106.879 10.5045H106.788Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.698 10.5046L112.874 3.39258V3.49517L106.788 10.5046H106.698Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.607 10.5047L112.874 3.28711V3.39272L106.698 10.5047H106.607Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.514 10.5048L112.874 3.18164V3.28725L106.607 10.5048H106.514Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.423 10.5049L112.874 3.0791V3.18169L106.514 10.5049H106.423Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.333 10.505L112.874 2.97363V3.07924L106.423 10.505H106.333Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.242 10.5042L112.875 2.86719V2.9728L106.333 10.5042H106.242Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.152 10.5052L112.874 2.76562V2.86822L106.242 10.5052H106.152Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.061 10.5054L112.874 2.66016V2.76576L106.152 10.5054H106.061Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.971 10.5045L112.874 2.55371V2.65932L106.061 10.5045H105.971Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88 10.5046L112.874 2.45117V2.55376L105.971 10.5046H105.88Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.786 10.5047L112.874 2.3457V2.45131L105.88 10.5047H105.786Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 10.4928L112.874 2.24023V2.34584L105.787 10.5049H105.708V10.4928Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 10.3873L112.874 2.13477V2.24037L105.708 10.4929V10.3873Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 10.2838L112.874 2.03125V2.13384L105.708 10.3864V10.2838Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 10.1783L112.874 1.92578V2.03139L105.708 10.2839V10.1783Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 10.0738L112.874 1.82129V1.9269L105.708 10.1794V10.0738Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.97032L112.874 1.71777V1.82036L105.708 10.0729V9.97032Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.86485L112.874 1.6123V1.71791L105.708 9.97046V9.86485Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.75939L112.874 1.50684V1.61244L105.708 9.86499V9.75939Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.65685L112.874 1.4043V1.50689L105.708 9.75944V9.65685Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.55138L112.874 1.29883V1.40444L105.708 9.65699V9.55138Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.44591L112.874 1.19336V1.29897L105.708 9.55152V9.44591Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.34239L112.874 1.08984V1.19243L105.708 9.44498V9.34239Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.2379L112.874 0.985352V1.09096L105.708 9.34351V9.2379Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.13146L112.874 0.878906V0.984515L105.708 9.23706V9.13146Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 9.02599L112.874 0.773438V0.879046L105.708 9.1316V9.02599Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.92345L112.874 0.670898V0.77349L105.708 9.02604V8.92345Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.8179L112.844 0.601562H112.874V0.670962L105.708 8.92351V8.8179Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.71229L112.754 0.601562H112.844L105.708 8.8179V8.71229Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.6097L112.663 0.601562H112.754L105.708 8.7123V8.6097Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.5041L112.573 0.601562H112.663L105.708 8.6097V8.5041Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.39849L112.482 0.601562H112.573L105.708 8.5041V8.39849Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.2959L112.389 0.601562H112.482L105.708 8.39849V8.2959Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.19029L112.298 0.601562H112.389L105.708 8.2959V8.19029Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 8.08468L112.208 0.601562H112.298L105.708 8.19029V8.08468Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.98209L112.117 0.601562H112.208L105.708 8.08468V7.98209Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.87648L112.027 0.601562H112.117L105.708 7.98209V7.87648Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.77087L111.936 0.601562H112.027L105.708 7.87648V7.77087Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.66526L111.846 0.601562H111.936L105.708 7.77087V7.66526Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.56267L111.752 0.601562H111.846L105.708 7.66526V7.56267Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.45706L111.661 0.601562H111.752L105.708 7.56267V7.45706Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.35145L111.571 0.601562H111.661L105.708 7.45706V7.35145Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.24886L111.48 0.601562H111.571L105.708 7.35145V7.24886Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.14325L111.39 0.601562H111.48L105.708 7.24886V7.14325Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.03765L111.299 0.601562H111.39L105.708 7.14325V7.03765Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.93505L111.209 0.601562H111.299L105.708 7.03765V6.93505Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.82945L111.118 0.601562H111.209L105.708 6.93505V6.82945Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.72384L111.025 0.601562H111.118L105.708 6.82945V6.72384Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.62125L110.934 0.601562H111.025L105.708 6.72384V6.62125Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.51564L110.844 0.601562H110.934L105.708 6.62125V6.51564Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.41003L110.753 0.601562H110.844L105.708 6.51564V6.41003Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.30442L110.663 0.601562H110.753L105.708 6.41003V6.30442Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.20183L110.572 0.601562H110.663L105.708 6.30442V6.20183Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 6.09622L110.482 0.601562H110.572L105.708 6.20183V6.09622Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.99061L110.388 0.601562H110.482L105.708 6.09622V5.99061Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.88802L110.298 0.601562H110.388L105.708 5.99061V5.88802Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.78241L110.207 0.601562H110.298L105.708 5.88802V5.78241Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.67681L110.117 0.601562H110.207L105.708 5.78241V5.67681Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.57421L110.026 0.601562H110.117L105.708 5.67681V5.57421Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.4686L109.935 0.601562H110.026L105.708 5.57421V5.4686Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.363L109.845 0.601562H109.935L105.708 5.46861V5.363Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.26041L109.751 0.601562H109.845L105.708 5.363V5.26041Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.1548L109.661 0.601562H109.751L105.708 5.26041V5.1548Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 5.04919L109.57 0.601562H109.661L105.708 5.1548V5.04919Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.94358L109.48 0.601562H109.57L105.708 5.04919V4.94358Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.84099L109.389 0.601562H109.48L105.708 4.94358V4.84099Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.73538L109.299 0.601562H109.389L105.708 4.84099V4.73538Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.62977L109.208 0.601562H109.299L105.708 4.73538V4.62977Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.52718L109.118 0.601562H109.208L105.708 4.62977V4.52718Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.42157L109.024 0.601562H109.118L105.708 4.52718V4.42157Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.31596L108.934 0.601562H109.024L105.708 4.42157V4.31596Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.21337L108.843 0.601562H108.934L105.708 4.31596V4.21337Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.10776L108.753 0.601562H108.843L105.708 4.21337V4.10776Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 4.00216L108.662 0.601562H108.753L105.708 4.10776V4.00216Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 3.89956L108.572 0.601562H108.662L105.708 4.00216V3.89956Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 3.79396L108.481 0.601562H108.572L105.708 3.89956V3.79396Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 3.68835L108.388 0.601562H108.481L105.708 3.79396V3.68835Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 3.58274L108.297 0.601562H108.388L105.708 3.68835V3.58274Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 3.48015L108.207 0.601562H108.297L105.708 3.58274V3.48015Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.207 0.601562L105.708 3.48015V0.601562H108.207Z",
    fill: "#818181"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.855 11.1738V16.8043H214.928V42.7025H209.298V16.8043H196.371V11.1738H227.855Z",
    fill: "#818181"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.963 11.1299V42.6586H186.333V28.2023H166.065V42.6586H160.434V11.1299H166.065V22.5688H186.333V11.1299H191.963Z",
    fill: "#818181"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.131 26.8956C130.131 32.4808 134.678 37.028 140.263 37.028H150.399V30.9932H140.263V25.3628H156.029V42.6585H140.263C131.57 42.6585 124.5 35.5857 124.5 26.8956C124.5 18.2056 131.573 11.1328 140.263 11.1328H156.029V16.7633H140.263C134.678 16.7633 130.131 21.3135 130.131 26.8987V26.8956Z",
    fill: "#818181"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7195 19.8673V19.6863C91.7195 18.1112 90.413 16.8047 88.8379 16.8047H76.0472C74.4722 16.8047 73.1656 18.1112 73.1656 19.6863V19.8673C73.1656 21.4424 74.4722 22.7489 76.0472 22.7489H87.3986C90.3255 22.7489 92.9386 24.0102 94.7399 25.9926C94.8757 26.1284 94.9632 26.2612 95.099 26.397C96.4961 28.1078 97.353 30.3165 97.353 32.7033C97.353 38.198 92.8933 42.6577 87.3986 42.6577H77.5348C72.0401 42.6577 67.5804 38.198 67.5804 32.7033H73.2109C73.2109 35.0901 75.148 37.0272 77.5348 37.0272H87.3986C89.7854 37.0272 91.7678 35.0901 91.7678 32.7033C91.7678 30.3165 89.7854 28.3794 87.3986 28.3794H76.0472C73.751 28.3794 71.6781 27.4802 70.1482 25.9926C69.7409 25.5853 69.3818 25.1357 69.065 24.6408C68.1206 23.2891 67.5804 21.6235 67.5804 19.8191V19.638C67.5804 14.955 71.3642 11.126 76.0472 11.126H88.8379C93.5239 11.126 97.35 14.955 97.35 19.638V19.8191L91.7195 19.8643V19.8673Z",
    fill: "#818181"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1267 11.1751V42.7038L57.4962 38.3799L37.2285 22.7529V42.7038H31.598V11.2657L37.2285 15.5896L57.4962 31.2196V11.1299L63.1267 11.1751Z",
    fill: "#818181"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0513 42.6586V11.1299H22.6817V42.6586H17.0513Z",
    fill: "#818181"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0189 11.1172H25.7777V16.7476H14.0189V11.1172Z",
    fill: "#818181"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0188 37.0664H25.7776V42.6968H14.0188V37.0664Z",
    fill: "#818181"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0151367 33.1016H1.72901V37.0362H9.61344V38.7501H1.72901V42.6848H0.0151367V33.1016Z",
    fill: "#818181"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.1162H9.5983V23.8301H5.19896V30.0006H9.5983V31.7145H0V30.0006H3.48206V23.8301H0V22.1162Z",
    fill: "#818181"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59193 19.0231H3.48206V12.8525H5.19594V19.0231H7.00637C7.48613 19.0231 7.88443 18.6248 7.88443 18.145V11.1387H9.5983V18.145C9.5983 19.5723 8.43359 20.7219 7.00637 20.7219H2.59193C1.16471 20.7219 0 19.5692 0 18.145V11.1387H1.71387V18.145C1.71387 18.6248 2.11217 19.0231 2.59193 19.0231Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fd7827440138e6342d94a169f21ab03.svg";
export { ForwardRef as ReactComponent };